var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("label", { class: _vm.$style.label }, [
      _vm._v("Search for Chain or Brand"),
    ]),
    _c("div", { class: _vm.$style.inputContainer }, [
      _c("input", {
        class: _vm.$style.input,
        attrs: { type: "text", placeholder: "Keywords here..." },
        domProps: { value: _vm.query },
        on: { input: _vm.search },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }